module.exports = __webpack_public_path__ + "static/media/lock.7926db17.svg";